import { Injectable } from '@angular/core';

import { Narrative } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class NarrativeService extends TmsWebBaseEditService<Narrative, Narrative> {
  constructor() {
    super('Narrative', $localize`Narrative`);
  }
}
